import React from "react";
import { ReactComponent as KudaLogo } from "../../../../assets/img/kudabank-logo.svg";
// import { ReactComponent as DarkIcon } from "../../../assets/img/darkIcon.svg";
// import { ReactComponent as LightIcon } from "../../../assets/img/lightIcon.svg";
import { StyledNonAuthHeader } from "../../../../styles/Auth/NonAuth.styles";
import { Link } from "react-router-dom";
import { Fragment } from "react";

export default function NonAuthHeader({ type }) {
  const userFromLogin = sessionStorage.getItem("userFromLogin");
  return (
    <StyledNonAuthHeader>
      <div className="flex justify-between align-center column--100 kuda-header--wrap">
        <Link to="/" className="kuda-brand">
          <KudaLogo />
        </Link>
        {!userFromLogin && (
          <Fragment>
            {type === "login" ? (
              <div className="kuda-header--actions">
                <Link href="https://kudabank.com/getKuda" className="kuda-cta kuda-cta-primary-light sign-in--button" rel="noopener noreferrer" to={type === "login" ? "/login" : "/get-started"}>
                  Sign in
                </Link>
              </div>
            ) : type === "authenticate" ? null : (
              <div className="kuda-header--actions">
                <Link href="https://kudabank.com/getKuda" className="kuda-cta kuda-cta-primary-light" rel="noopener noreferrer" to={type === "login" ? "/login" : "/get-started"}>
                  Open an Account
                </Link>
              </div>
            )}
          </Fragment>
        )}
      </div>
    </StyledNonAuthHeader>
  );
}
